const VOUCHERS_PER_PAGE = 12; // count of vouchers for page
const PDF_PER_PAGE = 12; // count of pdf`s for page

export {
  VOUCHERS_PER_PAGE,
  PDF_PER_PAGE,
};
